import React from "react";
import cellEditFactory from "react-bootstrap-table2-editor";
import BootstrapTable from "react-bootstrap-table-next";

import { priceFormat } from "utils/format";
import { TableButton } from "components/TableButton";
import { Trash2 } from "react-feather";

import { CutLink } from "components/CutLink";
import { useNomenclatureModal } from "contexts/NomenclatureModalContext";
import { SetNomenclatureModal } from "features/Supply/SetNomenclatureModal";
import { supplyFileImportUpdate } from "services/apiSupply";
import { Cut } from "components/Cut";

import "./acceptanceActProductTable.scss";

export const AcceptanceActProductTableNew = ({ products, setProducts }) => {
  const { openNomenclatureModal } = useNomenclatureModal();
  const removeProductsHandler = (index) => {
    setProducts((prev) => {
      prev.splice(
        prev.findIndex((val) => val.index === index),
        1
      );
      return [...prev];
    });
  };

  const updateData = () => {
    supplyFileImportUpdate(products)
      .then((res) => {
        setProducts(res.products);
      })
      .finally(() => {
        // setLoading(false);
      });
  };

  const tableProductsColumns = [
    {
      dataField: "index",
      text: "№",
      headerStyle: (colum, colIndex) => {
        return { width: "2%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "brand",
      text: "Бренд",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.brand}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "article",
      text: "Артикул",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.article}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "name",
      text: "Наименование",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.name}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "nomenclature",
      text: "Номенклатура",
      formatter: (cell, row) => {
        if (row.nomenclature?.id) {
          return (
            <Cut>
              {row.nomenclature?.article}, {row.nomenclature?.brand},{" "}
              {row.nomenclature?.name}
            </Cut>
          );
        } else {
          return (
            <SetNomenclatureModal
              product={row}
              products={products}
              updateData={updateData}
            />
          );
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "16%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "count",
      text: "Кол-во",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      headerClasses: () => "right",
      footerClasses: () => "right",
      classes: (cell, row) => "editable right",
      validator: (newValue, row) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: "Должны быть только цифры",
          };
        }
        if (newValue > row.countBefore) {
          return {
            valid: false,
            message: "Не должно быть больше чем кол-во",
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: "Кол-во не может быть меньше 0",
          };
        }
        return true;
      },
    },
    {
      dataField: "price",
      text: "Цена",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      headerClasses: () => "right",
      classes: () => "right",
      footerClasses: () => "right",
      formatter: (cell) => priceFormat(parseFloat(cell)),
      editable: false,
    },
    {
      dataField: "summ",
      text: "Сумма",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      headerClasses: () => "right",
      classes: () => "right",
      footerClasses: () => "right",
      formatter: (cell) => priceFormat(parseFloat(cell)),
      editable: false,
    },
    {
      dataField: "countryCode",
      text: "Код страны",
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      footer: () => null,
    },
    {
      dataField: "countryName",
      text: "Страна",
      formatter: (cell) => <span className="cute">{cell}</span>,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "gtd",
      text: "ГТД",
      formatter: (cell) => <span className="cute">{cell}</span>,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
      footer: () => null,
    },
    {
      dataField: "",
      text: "",
      formatter: (cell, row) => (
        <TableButton
          Icon={Trash2}
          onClick={() => removeProductsHandler(row.index)}
        />
      ),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      footer: () => null,
      editable: false,
    },
  ];

  const rowClasses = (row) => {
    if (row.nomenclature === null) {
      return "error";
    }
  };

  return (
    <>
      <BootstrapTable
        wrapperClasses="asseptance-act-product"
        keyField="id"
        data={products}
        hover={true}
        columns={tableProductsColumns}
        bootstrap4
        bordered={false}
        cellEdit={cellEditFactory({
          mode: "click",
          blurToSave: true,
        })}
        rowClasses={rowClasses}
      />
    </>
  );
};
